export default "__VITE_ASSET__UwF2Lc3a__"